<template>
  <div class="ocean-background"></div>
  <div class="world-map-container drop-shadow">
    <div class="world-map"></div>
  </div>
  <div  class="world-map-container">
    <div :class="'trade-route '+selectedRoute" style="overflow:hidden;">
      <div v-for="(m, mi) in locations" :key="'loc'+mi">
        <div v-if="isActive(m)" @click="doShowPopup(mi)" class="map-marker-box" :style="'left:' + markerPos(m).x + 'px; top:' + markerPos(m).y + 'px;'">
          <div :class="'map-marker '+ markerType(m)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorldMap",
  components: {},
  props: {
    route: String,
  },
  data() {
    return {
      widthS: 1750,
      heightS: 1125,
      svgW: 1750,
      svgH: 1125,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  computed: {
    locations() {
      return this.$store.getters.getLocations
    },
    cropping() {
      if (this.widthS / this.heightS < this.svgW / this.svgH) {
        return "width"
      } else {
        return "height"
      }
    },
    selectedRoute() {
      return this.$store.getters.getSelectedRoute
    }
  },
  methods: {
    markerType(marker) {
      if (marker.largeMarker) {
        let num = parseInt(this.selectedRoute.split("-")[1])
        if (num >= marker.largeMarker) {
          return "large-marker"
        }
        return ""
      } else {
        return ""
      }
    },
    markerPos(marker) {
      let scaleFactor = 1
      if (this.cropping == "height") {
        scaleFactor = this.widthS / this.svgW
      } else {
        scaleFactor = this.heightS / this.svgH
      }
      return {
        x: (marker.x - this.svgW * 0.5) * scaleFactor + this.widthS * 0.5,
        y: (marker.y - this.svgH * 0.5) * scaleFactor + this.heightS * 0.5
      }
    },
    resize() {
      this.widthS = window.innerWidth
      this.heightS = window.innerHeight
    },
    isActive(marker) {
      if (marker.active.includes(this.selectedRoute)) {
        return true
      } else {
        return false
      }
    },
    doShowPopup(index) {
      this.$store.commit("setSelectedLocationIndex", index)
      this.$store.commit("setShowPopup", !this.showPopup)
    }
  },
};
</script>

<style scoped>
.map-marker-box {
  position: absolute;
  transform-origin: center;
  padding: 3em;
  margin-left: -3em;
  margin-top: -3em;
  cursor: pointer;
}
.map-marker {
  width: 0.75em;
  height: 0.75em;
  margin-left: -0.375em;
  margin-top: -0.375em;
  border-radius: 100%;
  background-color: var(--indigo);
  filter: drop-shadow(0 0 0.25em var(--indigo))
          drop-shadow(0 0 0.25em var(--indigo));
  transition: 0.1s;
  position: relative;
}
.map-marker::after {
  content: "";
  width: 0.75em;
  height: 0.75em;
  top: -0.375em;
  left: -0.375em;
  border: 0.375em solid var(--white);
  border-radius: 100%;
  position: absolute;
}
.map-marker-box:hover .map-marker {
  background-color: var(--blue);
  transform: scale(1.5);
}
.world-map-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.drop-shadow {
  filter: drop-shadow(0 0 0.05em var(--indigo))
          drop-shadow(0 0 0.05em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 1em var(--indigo));
}
.trade-route {
  content: "";
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -10;
  align-items: center;
  overflow:hidden;
  transition: 0.25s;
}
.world-map {
  position: relative;
  content: "";
  background-image: url("../assets/images/dutch_indies_land.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -20;
  align-items: center;
  mask: url(../assets/images/world_map.svg) 100% 100%;
  mask-position: center;
  mask-size: cover;
}
.ocean-background {
  background-image: url("../assets/images/dutch_indies_ocean.jpg");
  background-position: center;
  background-repeat: repeat;
  position: fixed;
  width: 110%;
	height: 110%;
  top: 0;
  left: 0;
  z-index: -100;
	animation: ocean alternate 20s ease-in-out infinite;
}
@keyframes ocean {
	0% { transform: translate(0, 0); }
	100% { transform: translate(-10vw, -5vw); }
}
</style>